import React from 'react';
import Animate from 'src/components/animate';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import classNames from 'classnames';

class CollapsibleList extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    limit: PropTypes.number,
    mapper: PropTypes.func,
    emtpyState: PropTypes.string,
    showMoreUrl: PropTypes.string,
  };

  static defaultProps = {
    items: [],
    limit: -1, // Clip list at length of -1 for show all in collection
    mapper: obj => <li>{obj}</li>,
    onShowMoreClick: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  onShowMoreClick = e => {
    e.preventDefault();
    if (!this.props.showMoreUrl) {
      if (!this.state.expanded) {
        this.props.onShowMoreClick();
      }
      this.setState({ expanded: !this.state.expanded });
    } else {
      window.location.assign(this.props.showMoreUrl);
    }
  };

  render() {
    const { className, items, limit, mapper } = this.props;
    const hasLimit = limit > 0;
    const overLimit = items.length > limit;
    const editedCollection = hasLimit && !this.state.expanded ? items.slice(0, limit) : items;
    const list = editedCollection.map(mapper);
    const emtpyState = this.props.emtpyState || i18n.t('No items.');
    const iconClassName = classNames({
      icon: true,
      'icon-down-open': !this.state.expanded,
      'icon-up-open': this.state.expanded,
    });

    return (
      <ul className={className}>
        <Animate
          classNames="TRANSITION-simpleFade"
          timeout={{ enter: 0, exit: 0}}
        >
          {list.length > 0 ? list : <span>{emtpyState}</span>}
        </Animate>
        {hasLimit &&
          overLimit && (
            <div className="sidebar__show-more-btn">
              <a href="#" onClick={this.onShowMoreClick}>
                {!this.state.expanded ? i18n.t('view more posts') : i18n.t('show less posts')}{' '}
                <span className={iconClassName} />
              </a>
            </div>
          )}
      </ul>
    );
  }
}

export default CollapsibleList;
